/*!
 * pmk167
 * (c) 2019 kirsites <kirsites@gmail.com>
 * licensed under the MIT license
 */

(function () {

    $('.catalog-slider').each(function () {

        const $cs = $(this);

        if (!App.catSlider || !App.catSlider.length) return;

        const slides = App.catSlider;

        const $btnPrev = $('.slider-button._prev', $cs);
        const $btnNext = $('.slider-button._next', $cs);
        const $image   = $('.catalog-slider__image', $cs);

        const $content = $('.catalog-slider__content', $cs);
        const $title   = $('h2', $content);
        const $text    = $('p:first', $content);
        const $button  = $('.btn-outline', $content);
        const $buttonT = $('.btn-content', $button);

        let currentSlide = 0;

        function switchSlide(index) {
            $title.html(slides[index].title);
            $text.html(slides[index].text);
            $button.attr('href', slides[index].buttonLink);
            $buttonT.html(slides[index].buttonText);
            $image.css({ backgroundImage: `url(${slides[index].image})` });
        }

        switchSlide(currentSlide);

        $btnNext.on('click', function () {
            currentSlide++;
            if (currentSlide >= slides.length) currentSlide = 0;
            switchSlide(currentSlide);
        });

        $btnPrev.on('click', function () {
            currentSlide--;
            if (currentSlide < 0) currentSlide = slides.length - 1;
            switchSlide(currentSlide);
        });

    });

})();
